// react
import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";

// pages
import Layout from "./Layout/Layout";
import Login from "pages/Login/Login";
import Dashboard from "pages/Dashboard/Dashboard";
import Roadmap from "pages/Roadmap/Roadmap";
import Features from "pages/Features/Features";
import Users from "../pages/Users/Users";
import FeatureAddEdit from "pages/FeatureAddEdit/FeatureAddEdit";
import Comments from "../pages/Comments/Comments";
import UserAddEdit from "../pages/UserAddEdit/UserAddEdit";
import Page404 from "pages/404/Page404";

export default function Router() {
	// Title in browser tab for all App
	useEffect(() => {
		document.title = "Roadmap: Private-Radar";
	}, []);

	return (
		<Switch>
			<Route path="/" exact component={Login} />
			<Route path="/dashboard">
				<Layout children={<Dashboard />} />
			</Route>
			<Route path="/roadmap">
				<Layout children={<Roadmap />} />
			</Route>
			<Route exact path="/features">
				<Layout children={<Features />} />
			</Route>
			<Route exact path="/users">
				<Layout children={<Users />} />
			</Route>
			<Route path="/features/:id">
				<Layout children={<FeatureAddEdit />} />
			</Route>
			<Route path="/comments/:id">
				<Layout children={<Comments />} />
			</Route>
			<Route path="/users/:id">
				<Layout children={<UserAddEdit />} />
			</Route>
			<Route component={Page404} />
		</Switch>
	);
}
